import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Link, useRouter } from '@/lib/navigation';
import { useTranslation } from '@/hooks/useTranslation';
import { useToastStore } from '@/store';
import { openPublicPage } from '@/lib/openPublicPage';
import SidebarGetAppDropdown from './SidebarGetAppDropdown';
import SidebarListItemLayout from './SidebarListItemLayout';

const helpLinksStyles = StyleSheet.create({
  // Rendered inline inside the logged-out nav list (which already provides the
  // 8px horizontal gutter), so no extra horizontal padding here — just a small
  // top gap to separate it from "Create Music".
  container: {
    paddingTop: 6,
    paddingBottom: 10,
  },
});

// Logged-out footer links shown inline beneath "Create Music" in the nav list.
const SidebarHelpLinks = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { addToast } = useToastStore(state => state.actions);
  const openDocs = async () => {
    try { await openPublicPage('/docs', router); }
    catch (_) { addToast(t('settings.help.linkError'), 'error'); }
  };
  const docs = <SidebarListItemLayout
    id="help-documentation" title={t('sidebar.apiDocumentation')}
    icon="book-open" noEllipsis
    {...(Platform.OS !== 'web' && { onPress: openDocs })}
  />;

  return <View style={helpLinksStyles.container}>
    <SidebarGetAppDropdown />
    {Platform.OS === 'web' ? <Link href="/docs" asChild withAnchor>{docs}</Link> : docs}
  </View>;
};

export default SidebarHelpLinks;
